import { HelpArticleContent } from "@/@types/help/Articles";
import Link from "next/link";
import React, { useState } from "react";
import {
  AccordionItem,
  AccordionHeader,
  AccordionBody,
  Accordion,
} from "reactstrap";
import classes from "@/styles/help/content-section.module.css";

interface Props {
  content: HelpArticleContent;
  color?: string;
}

const ContentSection = ({ content: { about, data }, color }: Props) => {
  const [open, setOpen] = useState(data[0].subLink);
  const [activeLink, setActiveLink] = useState(data[0].name);

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  return (
    <div>
      <h5 className="fw-bold">In this Article</h5>
      <div>
        <ul>
          {data.map((sec, i) => (
            <li className="my-2" key={i}>
              <Link
                className={
                  activeLink === sec.name ? classes.linkActive : classes.link
                }
                onClick={() => {
                  setActiveLink(sec.name);
                  toggle(sec.name);
                }}
                href={`#${sec.subLink}`}
              >
                {sec.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <h6 className="fw-bold mt-4 mb-2">About</h6>
      <div>{about ?? "No description available."}</div>
      <h6 className="fw-bold mt-4 mb-2">Content</h6>
      {/*@ts-ignore*/}
      <Accordion open={open} toggle={toggle}>
        {data?.map((sec, i) => (
          <AccordionItem key={i}>
            <AccordionHeader targetId={sec.subLink}>{sec.name}</AccordionHeader>
            <AccordionBody accordionId={sec.subLink}>
              {sec.content}
            </AccordionBody>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};

export default ContentSection;
